import {
	blue25, blue50, blue200, blue300, blue400, blue700,
	neutral50, neutral100, neutral200, neutral300, neutral400, neutral700, neutralWhite, neutralBlack, neutralDisabled,
	orangeRestricted,
	primary25, primary50, primary100, primary200, primary300, primary400, primary500, primary800,
	red25, red75, red100, red400, red500, red600,
	redAlpha100,
} from './colors';

export const mainTheme = {
	name: 'Main',
	primaryTextColor: primary800,
	form: {
		label: {
			color: primary800,
			requiredAsteriskColor: red400,
			fontWeight: 500,
			fontSize: 14,
		},
		requiredAsterisk: {
			color: red400,
			fontWeight: 500,
		},
		error: {
			fontWeight: 400,
			fontSize: 14,
			color: red500,
		},
		input: {
			accentColor: blue400,
			border: neutral200,
			error: {
				border: red400,
				shadow: `0px 0px 0px 2px ${red75}`,
			},
			focus: {
				border: blue400,
				shadow: `0px 0px 0px 3px ${blue50}`,
			},
			color: primary800,
			placeholderColor: neutral400,
			size: {
				default: {
					height: 40,
					fontSize: 14,
					iconSize: 16,
					padding: '8px 10px',
				},
				small: {
					height: 32,
					fontSize: 14,
					iconSize: 14,
					padding: '4px 10px',
				}
			}
		},
		radio: {
			default: {
				border: neutral300,
				background: neutralWhite,
			},
			focus: {
				border: blue300,
				shadow: `0px 0px 0px 3px ${blue50}`,
			},
			checked: {
				border: blue300,
				background: neutralWhite,
			}
		},
		checkbox: {
			default: {
				border: neutral300,
				background: neutralWhite,
			},
			focus: {
				border: blue300,
				shadow: `0px 0px 0px 3px ${blue50}`,
			},
			checked: {
				border: blue300,
				background: blue300,
			}
		},
		dropdown: {
			chevron: {
				color: neutral300,
			},
			menu: {
				default: neutralWhite,
				shadow: '0px 6px 12px 0px rgba(0, 0, 0, 0.18)',
				selected: blue25,
				hover: blue25,
				disabled: {
					color: neutralDisabled,
				},
				danger: {
					color: red500,
				}
			},
			restricted: {
				border: orangeRestricted,
			},
		},
		help: {
			color: neutral700,
		},
		disabled: {
			opacity: 0.5,
			background: neutral50,
		},
		border: {
			width: 1,
			radius: 2,
		},

		multiSelectInput: {
			itemBackground: neutral100,
			removeIcon: primary100,
			removeIconHover: primary300,
			itemColor: primary400,
		},

		multiSelectDropdown: {
			size: {
				default: {
					height: 40,
					padding: '8px 10px',
					fontSize: 14,
				},
				small: {
					height: 32,
					padding: '4px 10px',
					fontSize: 14,
				}
			}
		}

	},
	stepper: {
		stepIndicator: {
			primary: {
				background: blue400,
				color: neutralWhite,
			},
			neutral: {
				background: primary50,
				color: neutral700,
			}
		},
		stepLabel: {
			primary: {
				color: blue700,
			},
			neutral: {
				color: neutral700,
			},
		},
		stepButton: {
			color: blue400,
		}
	},
	slideIn: {
		overlay: neutralBlack,
		title: {
			color: primary800,
			fontWeight: 500,
			fontSize: 18,
		},
		background: neutralWhite,
		closeIcon: {
			color: primary200,
			hover: primary300,
		},
		border: neutral100,
	},
	card: {
		title: primary800,
		subtitle: primary200,
		color: primary500,
		background: neutralWhite,
		default: {
			border: neutral200,
		},
		selected: {
			border: blue400,
			boxShadow: blue50
		}
	},
	tabs: {
		error: {
			color: red500,
			icon: red500,
		},
		highlight: blue300,
		default: {
			color: primary200,
			icon: primary200,
		},
		hover: {
			color: primary400,
			icon: primary400,
		},
		active: {
			color: primary800,
			icon: primary400,
		},
	},
	initials: {
		background: primary200,
		color: neutralWhite,
	},
	font: '"Red Hat Display"',
	upgradePages: {
		boxShadow: '0px 6px 12px 0px rgba(32, 56, 87, 0.18)',
		focus: {
			shadow: `0px 0px 0px 3px ${blue400}`,
		}
	},
	featureText: {
		color: primary200
	},
	slider: {
		track: {
			background: primary25,
		},
		thumb: {
			background: blue400,
			border: blue400,
			fill: neutralWhite,
		},
	},
	widgetStatus: {
		neutral: {
			color: primary100,
		},
		warning: {
			color: primary100,
			iconColor: red500,
		},
		error: {
			color: neutralWhite,
			background: redAlpha100,
			iconColor: neutralWhite,
		},
	},
	aiChat: {
		card: {
			background: neutralWhite,
			border: neutral200,
			shadow: '0px 4px 16px 0px rgba(2, 23, 51, 0.12)',
		},
		header: {
			title: primary800,
			border: neutral100,
			background: neutralWhite,
		},
		messageList: {
			background: neutralWhite,
		},
		message: {
			user: {
				background: blue25,
				color: primary800,
			},
			assistant: {
				background: primary25,
				color: primary800,
			},
			error: {
				background: red25,
				color: red600,
				border: red100,
			},
		},
		input: {
			background: neutralWhite,
			border: neutral200,
			focusBorder: blue400,
			focusShadow: `0px 0px 0px 3px ${blue50}`,
			placeholder: neutral400,
			color: primary800,
		},
		pill: {
			background: primary500,
			backgroundHover: primary400,
			color: neutralWhite,
			expandedBorder: blue200,
			expandedHalo: `0 0 0 3px ${blue50}`,
			expandedBackground: neutralWhite,
			leadingIcon: blue400,
			placeholder: neutral400,
			sendBackground: primary500,
			sendBackgroundHover: primary400,
			sendColor: neutralWhite,
		},
	},

};
